import React, { useEffect, useState, Suspense } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { Cloud, Code, Cpu, GitBranch, Server, Settings, Terminal } from 'lucide-react';

// Lazy load pages for optimization
const Home = React.lazy(() => import('./pages/Home'));
const About = React.lazy(() => import('./pages/About'));
const Services = React.lazy(() => import('./pages/Services'));
const Projects = React.lazy(() => import('./pages/Projects'));
const Contact = React.lazy(() => import('./pages/Contact'));
const Careers = React.lazy(() => import('./pages/Careers'));

// Loader component
const Loader = () => (
  <div className="loader-overlay">
    <div className="loader">
      <Code className="loader-icon" />
      <Terminal className="loader-icon" />
      <GitBranch className="loader-icon" />
      <Server className="loader-icon" />
      <Cloud className="loader-icon" />
      <Cpu className="loader-icon" />
      <Settings className="loader-icon" />
    </div>
  </div>
);

const App = () => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Show loader on route change
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 1000); // Simulate loading time
    return () => clearTimeout(timer);
  }, [location]);

  return (
    <div className="App">
      <Navbar />
      <main>
        {loading && <Loader />}
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/careers" element={<Careers />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </div>
  );
};

// Wrapper to handle Router and Location
const AppWrapper = () => (
  <Router>
    <App />
  </Router>
);

export default AppWrapper;
